import React, { FC } from 'react'
import { createLinkBasedOnType, isExternalURL } from '../../../../utils/link.utils'
import Typography from '../../typography'

type Props = {
  platformDiagramData: any
}

export const NavigationGroup: FC<Props> = ({ platformDiagramData }) => (
  <div className="PlatformDiagram__Navigation-Group">
    {platformDiagramData.megamenu.pages?.map((group: any, i: number) => {
      const labelColor = group.groupNameColor
        ? `--${group.groupNameColor.toLowerCase()}`
        : '--black'

      return (
        <div className="PlatformDiagram__Nav-Item" key={`menuGroup--${i}`}>
          <Typography
            className={`PlatformDiagram__Nav-Item-Heading Menu-container-label${labelColor}`}
            type="header6">
            {group.newGroupName}
          </Typography>

          <Typography className="PlatformDiagram__Nav-Item-Description font__inter" type="bodyXS">
            {group.menuGroupDescription}
          </Typography>

          {group.pages?.map((page: any, k: number) => {
            let target
            const parentLinkHref = createLinkBasedOnType(page)

            if (isExternalURL(parentLinkHref)) {
              target = '_blank'
            } else {
              target = '_self'
            }

            return (
              <a
                href={parentLinkHref}
                key={`menuGroupPage--${k}`}
                target={target}
                className="PlatformDiagram__Nav-Item-Link">
                {page.text}
              </a>
            )
          })}
        </div>
      )
    })}
  </div>
)
